import { AnnotationsMarkerProps } from '../../core/components/annotations/types/annotations-marker-props.js';

export const Marker = (props: AnnotationsMarkerProps) => null;

Marker['displayName'] = 'Annotations.Marker';
